export const isIP = ipAddress => {
  // Regular expression patterns for IPv4 and IPv6
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6Pattern = /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/;

  if (ipv4Pattern.test(ipAddress)) {
    // Valid IPv4 address
    return true;
  } else if (ipv6Pattern.test(ipAddress)) {
    // Valid IPv6 address
    return true;
  } else {
    // Invalid IP address
    return false;
  }
};
